export default function Profile(){return <div><h1 className="text-2xl font-black">Profile</h1><input className="input mt-4" placeholder="Name"/><input className="input mt-3" placeholder="Email"/></div>;}
